import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { asArray } from '@olivierpascal/helpers';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { Elevation } from '../Elevation';
import { paperBaseElevationStyles, paperBaseStyles } from './PaperBase.styles';
import { paperBaseTheme } from './PaperBase.stylex';
import { Base } from '../Base';
// https://github.com/material-components/material-web/blob/main/labs/paperBase/internal/paperBase.ts
export const PaperBase = createPolymorphicComponent(forwardRef(function PaperBase(props, forwardedRef) {
    const { styles, sx, innerStyles, children, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'PaperBase',
        styles: [paperBaseStyles, styles],
    });
    return (_jsxs(Base, { ...other, sx: [paperBaseTheme, globalStyles, combineStyles('host'), sx], ref: forwardedRef, children: [_jsx(Elevation, { styles: [
                    paperBaseElevationStyles,
                    ...asArray(innerStyles?.elevation),
                ] }), _jsx("div", { ...getStyles('outline') }), _jsx("div", { ...getStyles('background') }), children] }));
}));
